<div class="quiz-summary">
  <h2 class="summary-title">{{'game-mode.quiz.finish' | translate}}</h2>

  <!-- Stats Grid -->
  <div class="stats-grid">
    <div class="stat-card">
      <span class="stat-value correct-color">{{correctAnswers | arabicNumber:currLang}}</span>
      <span class="stat-label">{{'game-mode.quiz.correct' | translate}}</span>
    </div>
    <div class="stat-card">
      <span class="stat-value incorrect-color">{{totalQuestions - correctAnswers | arabicNumber:currLang}}</span>
      <span class="stat-label">{{'game-mode.quiz.incorrect' | translate}}</span>
    </div>
    <div class="stat-card">
      <span class="stat-value accuracy-color">{{accuracy | arabicNumber:currLang}}%</span>
      <span class="stat-label">{{'game-mode.quiz.accuracy' | translate}}</span>
    </div>
    <div class="stat-card xp-card">
      <span class="stat-value xp-color">+{{totalXP | arabicNumber:currLang}}</span>
      <span class="stat-label">{{'game-mode.quiz.xp-earned' | translate}}</span>
    </div>
  </div>

  <!-- Phase 2: Creature with XP Bar (hidden for Phase 1)
  <div class="creature-section" *ngIf="creature">
    <app-creature-display
      [creatureTypeId]="creature.creatureTypeId"
      [pose]="accuracy >= 50 ? 'happy' : 'sad'"
      [level]="creature.level"
      [size]="'large'">
    </app-creature-display>
    <div class="creature-stats">
      <span class="creature-name">{{creature.customName}}</span>
      <app-xp-bar [creature]="creature"></app-xp-bar>
      <app-league-badge [level]="creature.level"></app-league-badge>
    </div>
  </div>
  -->

  <!-- Actions -->
  <div class="summary-actions">
    <button class="action-btn primary" (click)="finish()">
      {{'game-mode.hub.back' | translate}}
    </button>
  </div>
</div>
